import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import "./companyProfile.scss";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const CompanyProfile = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["companyProfileData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/page/detail/company-profile`)
        .then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;

  if (error) return "An error has occurred: " + error.message;

  // Select description based on language
  const description = nep
    ? data?.detail?.np?.Description
    : data?.detail?.en?.Description;

  return (
    <div>
      <div
        style={{ textAlign: "justify", hyphens: "auto" }}
        className="companyProfileCKContainer"
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>
    </div>
  );
};

export default CompanyProfile;
